<template>
  <v-app-bar app color="primary" dark>
    <slot name="bar-nav-icon"></slot>
  </v-app-bar>
</template>

<script>
export default {
  name: "RwHeader",
  methods: {
    changeMenu() {
      this.drawerMenu = !this.drawerMenu;
    }
  }
};
</script>
